import { authService } from '@/features/auth/services/authService';
import { BaseAuthState, createBaseAuthStore } from '@tickitacka/shared';
import {
    UserTodoDisplaySetting,
    UserWithDisplaySettings,
} from '../common/types/databaseTypes';

// AppUser 타입을 정의
type AppUser = UserWithDisplaySettings;

// 확장된 인증 상태 타입
interface AuthState extends BaseAuthState {
    user: AppUser | null;
    checkUser: () => Promise<AppUser | null>;
    updateUser: (userData: Partial<AppUser>) => void;
    updateTodoDisplaySettings: (
        settings: Partial<UserTodoDisplaySetting>
    ) => void;
}

// 타입 명시적 선언을 통한 zustand 참조 오류 해결
type AppAuthStore = ReturnType<typeof createBaseAuthStore<AuthState>>;

// 타입이 지정된 기본 authStore를 생성합니다
export const useAuthStore: AppAuthStore =
    createBaseAuthStore<AuthState>(authService);

// TodoDisplaySettings 업데이트 기능 추가
const { getState, setState } = useAuthStore;

// 원래 스토어에서 상태를 가져와서 새 함수 추가
const originalState = getState();
setState({
    ...originalState,
    updateTodoDisplaySettings: (settings: Partial<UserTodoDisplaySetting>) => {
        setState(state => ({
            ...state,
            user: state.user
                ? {
                      ...state.user,
                      todo_display_setting: {
                          ...state.user.todo_display_setting,
                          ...settings,
                      },
                  }
                : null,
        }));
    },
});
